"use client";

const values = [
  {
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <circle cx="24" cy="18" r="7" stroke="#7c6af7" strokeWidth="2" />
        <circle cx="14" cy="20" r="5" stroke="#7c6af7" strokeWidth="2" />
        <circle cx="34" cy="20" r="5" stroke="#7c6af7" strokeWidth="2" />
        <path d="M6 38c0-5 3.5-8 8-8h1M42 38c0-5-3.5-8-8-8h-1M12 38c0-5.5 5-9 12-9s12 3.5 12 9" stroke="#7c6af7" strokeWidth="2" strokeLinecap="round" />
      </svg>
    ),
    title: "People First",
    description: "We prioritize our people and foster a culture of respect, trust and care.",
  },
  {
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <path d="M24 8C17.4 8 12 13.4 12 20c0 4.5 2.5 8.4 6 10.5V34h12v-3.5c3.5-2.1 6-6 6-10.5 0-6.6-5.4-12-12-12z" stroke="#7c6af7" strokeWidth="2" />
        <path d="M18 34v4h12v-4" stroke="#7c6af7" strokeWidth="2" strokeLinecap="round" />
        <line x1="24" y1="8" x2="24" y2="5" stroke="#7c6af7" strokeWidth="2" strokeLinecap="round" />
        <line x1="10" y1="20" x2="7" y2="20" stroke="#7c6af7" strokeWidth="2" strokeLinecap="round" />
        <line x1="41" y1="20" x2="38" y2="20" stroke="#7c6af7" strokeWidth="2" strokeLinecap="round" />
        <line x1="13.5" y1="11.5" x2="11.5" y2="9.5" stroke="#7c6af7" strokeWidth="2" strokeLinecap="round" />
        <line x1="36.5" y1="11.5" x2="34.5" y2="9.5" stroke="#7c6af7" strokeWidth="2" strokeLinecap="round" />
        <circle cx="24" cy="20" r="3" stroke="#7c6af7" strokeWidth="1.5" />
      </svg>
    ),
    title: "Innovate Boldly",
    description: "We encourage new ideas and empower everyone to challenge the norm.",
  },
  {
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <circle cx="24" cy="24" r="14" stroke="#7c6af7" strokeWidth="2" />
        <circle cx="24" cy="24" r="9" stroke="#7c6af7" strokeWidth="2" />
        <circle cx="24" cy="24" r="4" stroke="#7c6af7" strokeWidth="2" />
        <circle cx="24" cy="24" r="1.5" fill="#7c6af7" />
      </svg>
    ),
    title: "Own the Impact",
    description: "We take ownership and deliver meaningful results together.",
  },
  {
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <path d="M28 10l-8 10h6l-4 18 14-20h-7l5-8h-6z" stroke="#7c6af7" strokeWidth="2" strokeLinejoin="round" />
        <path d="M12 22c-2 1.5-3 4-2 6.5" stroke="#7c6af7" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="12" cy="16" r="2" stroke="#7c6af7" strokeWidth="1.5" />
      </svg>
    ),
    title: "Grow Together",
    description: "We learn, share and elevate each other every single day.",
  },
  {
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <path d="M24 36s-14-8-14-18a14 14 0 0128 0c0 10-14 18-14 18z" stroke="#7c6af7" strokeWidth="2" />
        <path d="M20 18c0 0 2-3 4 0s4 0 4 0" stroke="#7c6af7" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M17 24c2 2 4 3 7 3s5-1 7-3" stroke="#7c6af7" strokeWidth="1.5" strokeLinecap="round" />
        <path d="M22 12v2M26 12v2" stroke="#7c6af7" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    ),
    title: "Be Kind",
    description: "We create a positive space where everyone feels valued.",
  },
  {
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <circle cx="24" cy="24" r="14" stroke="#7c6af7" strokeWidth="2" />
        <ellipse cx="24" cy="24" rx="7" ry="14" stroke="#7c6af7" strokeWidth="2" />
        <line x1="10" y1="24" x2="38" y2="24" stroke="#7c6af7" strokeWidth="2" />
        <line x1="12" y1="16" x2="36" y2="16" stroke="#7c6af7" strokeWidth="1.5" />
        <line x1="12" y1="32" x2="36" y2="32" stroke="#7c6af7" strokeWidth="1.5" />
      </svg>
    ),
    title: "Think Global",
    description: "We solve problems with a global mindset and local heart.",
  },
];

export default function ValuesSection() {
  return (
    <section className="bg-background-primary py-10! px-6! md:px-12!  2xl:px-24! w-full font-sans box-border">
      <p className="text-purple-600 dark:text-purple-500 text-xs font-semibold tracking-widest uppercase m-0! mb-3!">What Makes Us, Us</p>

      <h2 className="text-text-primary text-3xl md:text-[32px] 2xl:text-[38px] font-bold m-0! mb-10! leading-tight">Built on Values. Driven by People.</h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4 w-full">
        {values.map((v, i) => (
          <div
            key={i}
            className="border border-border-primary rounded-[12px] p-7! pb-6! flex flex-col gap-4 items-center text-center transition-all duration-300 cursor-default hover:border-purple-500/50"
            style={{
              background: "var(--card-background)",
              boxShadow: "var(--card-shadow)",
            }}
          >
            <div className="leading-none!">{v.icon}</div>

            <h3 className="text-text-primary text-[15px] 2xl:text-[17px] font-semibold m-0! leading-snug">{v.title}</h3>

            <p className="text-text-secondary text-[13px] 2xl:text-[14px] leading-relaxed m-0!">{v.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
